export const api_url =  window.API_URL;// "https://172.16.88.156:14998";       // Backend url
export const resource_url = window.RESOURCE_RUL;//"http://172.16.88.156:14904";  // Backend resource url
export const per_page = 5;                                  // Item count on one page - using in pagenation
export const common_url = '../images/Page/';
export const ws_api_url = window.WS_API_URL;//"wss://172.16.88.156:14998/stream";       // Backend socket url


// WEBPACK FOOTER //
// ./src/common/cores/keys.js